import type { GeneratedFile, GeneratorOptions, Schema } from '@cli-types/core-engine/schema.js'
import { createGeneratedFile } from '@cli-utils/files.js'
import { singularize, toPascalCase } from '@cli-utils/text.js'
import { resolveSchemaActionImportPath } from '@next-adapter/config/paths/resolve-schema-action-import-path.js'
import { renderCreateCustomCellComponentComponentTemplate } from '@next-adapter/templates/renderers/generators/columns/custom-cell.js'

export function createCustomCellComponent(
  schema: Schema,
  componentName: string,
  pagesDir: string,
  options: GeneratorOptions = {}
): GeneratedFile[] {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const actionImportPath = resolveSchemaActionImportPath(schema.name, options.outputNamespace)

  const content = renderCreateCustomCellComponentComponentTemplate({
    singular: Singular,
    actionImportPath: actionImportPath,
    componentName: componentName
  })

  return [createGeneratedFile(`${pagesDir}/${schema.name}/cells/${componentName}.tsx`, content)]
}
